import { store } from "../../redux/store";
import { ExecutorLocations } from "../../services";

/** Как на бэке в DEFAULT_MAP_SETTINGS, если у парка нет своего TTL. */
export const DEFAULT_EXECUTOR_COORDINATES_TTL_MS = 60_000;

export const minExecutorCoordinatesTtlMs = (
	models: { settings?: { map?: { general?: { executorCoordinatesTTL?: number } } } }[],
): number => {
	let minTtl = DEFAULT_EXECUTOR_COORDINATES_TTL_MS;
	for (let i = 0; i < models.length; i += 1) {
		const ttl = Number(
			models[i]?.settings?.map?.general?.executorCoordinatesTTL,
		);
		if (Number.isFinite(ttl) && ttl > 0 && ttl < minTtl) minTtl = ttl;
	}
	return minTtl;
};

const ttlFromTaxiService = (taxiServiceId?: number): number => {
	if (!taxiServiceId) return DEFAULT_EXECUTOR_COORDINATES_TTL_MS;
	const models = store.getState().taxiServices?.models || [];
	const taxiService = models.find((item) => item.id === taxiServiceId);
	const ttl = Number(
		taxiService?.settings?.map?.general?.executorCoordinatesTTL,
	);
	if (!Number.isFinite(ttl) || ttl <= 0) {
		return DEFAULT_EXECUTOR_COORDINATES_TTL_MS;
	}
	return ttl;
};

const locationTimeMs = (date: ExecutorLocations.Model["date"]): number => {
	if (typeof date === "number") return date;
	if (typeof date === "string") {
		const parsed = Date.parse(date);
		return Number.isFinite(parsed) ? parsed : NaN;
	}
	return NaN;
};

/** Та же формула, что isExecutorGpsFresh на раздаче: точка + date в пределах TTL. */
export const isExecutorMapGpsFresh = (
	location: ExecutorLocations.Model,
	now = Date.now(),
): boolean => {
	if (!location?.point) return false;
	const at = locationTimeMs(location.date);
	if (!Number.isFinite(at)) return false;
	return now - at <= ttlFromTaxiService(location.taxiServiceId);
};

/** Тик opacity: половина минимального TTL по паркам, не чаще 10 с. */
export const gpsStaleTickMsFromModels = (
	models: { settings?: { map?: { general?: { executorCoordinatesTTL?: number } } } }[],
): number =>
	Math.max(10_000, Math.floor(minExecutorCoordinatesTtlMs(models) / 2));
